import { render } from "./SubfunctionTour.vue?vue&type=template&id=23956845&scoped=true&ts=true"
import script from "./SubfunctionTour.vue?vue&type=script&lang=ts"
export * from "./SubfunctionTour.vue?vue&type=script&lang=ts"

import "./SubfunctionTour.vue?vue&type=style&index=0&id=23956845&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23956845"]])

export default __exports__